export default __webpack_public_path__ + "static/media/why-us-3.ea8b5f46.jpg";